import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleEnum } from '@app/shared/enum/role.enum';
import { Store } from '@ngxs/store';
import { StateResetAll } from 'ngxs-reset-plugin';
import * as AuthAction from '@app/store/auth/auth.actions';
import { AuthState } from '@app/store/auth/auth.state';
import { SetActiveRoute } from '@app/core/store/config/config.actions';
import { ITradeInSystemItem } from '@shared/interfaces/tradein-system-item.interface';
import { TradeInSytemCollection } from '@app/shared/models/tradein-system.collection';

@Component({
  selector: 'app-menu-toolbar',
  templateUrl: './menu-toolbar.component.html',
  styleUrls: ['./_menu-toolbar.component.sass'],
})
export class MenuToolbarComponent implements OnInit {
  @Input() user: any;
  menuList: ITradeInSystemItem[] = TradeInSytemCollection;

  constructor(private _router: Router, private _store: Store) {}

  ngOnInit(): void {
    const auth = this._store.selectSnapshot(AuthState);
    this.menuList = this.menuList.filter((menu) => auth.roles.includes(menu.role));
  }

  logout() {
    this._store.dispatch(new StateResetAll());
    this._store.dispatch(new AuthAction.CleanToken());
    this._router.navigate(['login']);
  }

  selectTradinProgram(selectedMenuItem: ITradeInSystemItem) {
    const [route] = selectedMenuItem.route;
    this._store.dispatch(new SetActiveRoute(route));
    this._router.navigate([`${route}`]);
  }
}
